// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.villasDetails {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1em;
  background: var(--clr-light);
  right: -100rem;

  /* bottom: 7.75rem; */
  bottom: 0;
  z-index: 1003;
  overflow-y: scroll;
  scrollbar-width: none;
  transition: 0.25s;
  overflow-x: hidden;
  display: flex;
  pointer-events: none;
  justify-content: space-between;
  flex-direction: column;
  /* box-shadow: -0.25rem 0 0.75rem rgba(0, 0, 0, 0.01); */
}

.villasDetails.show {
  right: 0;
  pointer-events: all;
}

.villasDetails.show.close {
  right: -100rem;
  pointer-events: none;
}

.villasDetails::-webkit-scrollbar {
  display: none;
}

.villasDetails__imgContainer {
  position: relative;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
}

.villasDetails__closeIcon {
  position: absolute;
  left: 0.75rem;
  width: 1.5rem;
  top: 0.75rem;
  cursor: pointer;
  z-index: 1;
}

.villasDetails__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
  border-radius: 1em;
  position: relative;
  z-index: 10;
}

.villasDetails__imgContainer {
  background-color: var(--clr-gray300);
  width: 100%;
  height: 15rem;
  object-fit: cover;
  cursor: zoom-in;
  border-radius: 1em;
}
.villasDetails__imgContainer::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
}

.villasDetails__img:hover {
  opacity: 0.8;
}

.villasDetails__title {
  font-weight: bolder;
  font-size: 2rem;
  margin-top: 1rem;
}

.villasDetails__moreDetails {
  display: block;
  margin: 0.75rem 0;
}

.villasDetails__description,
.villasDetails__moreDetails {
  line-height: 1.8;
  white-space: pre-wrap;
}

.villasDetails__description {
  color: var(--clr-gray800);
  font-weight: 200;
}

.villasDetails__bottom {
  display: flex;
  align-items: center;
  position: sticky;
  justify-content: space-between;
  width: calc(100% + 2rem);
  padding: 1em;
  bottom: -1rem;
  margin: 1rem 0 -1rem -1rem;
  background: var(--clr-secondary);
}

.villasDetails__price {
  font-size: 1.5rem;
  /* font-size: 3rem; */
  font-weight: 500;
  color: var(--clr-primary);
}

.villasDetails__price small {
  font-weight: 700;
  font-size: 1.5rem;
}

.villasDetails__bottom button {
  border-radius: 1em;
}
.villasDetails__bottom button i {
  margin-left: 1rem;
}

.villasDetails .btn.selected {
  background: #fff;
  border: 1px solid var(--clr-success-dark);
  color: var(--clr-success-dark);
}

.villasDetails .btn.selected i::before,
.villasDetails .btn.selected i::after {
  background: var(--clr-success-dark);
}

.villaDetails__activityContainer h4 {
  font-size: 1.15rem;
  margin-top: 1.5rem;
  font-weight: 500;
}

.villaDetails__activities {
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
}

.villaDetails__activities li img {
  width: 100%;
  max-width: 2.5rem;
  display: block;
}
.villaDetails__activities li {
  display: flex;
  padding: 0.75em 1em;
  margin-right: 0.35rem;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  background: var(--clr-secondary);
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  border-radius: 0.5em;
}

/* @media (min-width: 425px) {
  .villasDetails__price {
    font-size: 3rem;
  }
} */

@media (min-width: 768px) {
  .villasDetails {
    width: 60%;
    border-radius: 1em 0 0 1em;
  }
}

@media (min-width: 992px) {
  .villasDetails {
    width: 40%;
  }

  .villasDetails__imgContainer {
    height: 22rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VillasComponents/VillasDetails/VillasDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,cAAc;;EAEd,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;;EAU5B;;;;;GAKC;;EAED,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;GAIG;;AAEH;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".villasDetails {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  padding: 1em;\n  background: var(--clr-light);\n  right: -100rem;\n\n  /* bottom: 7.75rem; */\n  bottom: 0;\n  z-index: 1003;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  transition: 0.25s;\n  overflow-x: hidden;\n  display: flex;\n  pointer-events: none;\n  justify-content: space-between;\n  flex-direction: column;\n  /* box-shadow: -0.25rem 0 0.75rem rgba(0, 0, 0, 0.01); */\n}\n\n.villasDetails.show {\n  right: 0;\n  pointer-events: all;\n}\n\n.villasDetails.show.close {\n  right: -100rem;\n  pointer-events: none;\n}\n\n.villasDetails::-webkit-scrollbar {\n  display: none;\n}\n\n.villasDetails__imgContainer {\n  position: relative;\n  overflow: hidden;\n  -webkit-mask-image: -webkit-radial-gradient(white, black);\n}\n\n.villasDetails__closeIcon {\n  position: absolute;\n  left: 0.75rem;\n  width: 1.5rem;\n  top: 0.75rem;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.villasDetails__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: zoom-in;\n  border-radius: 1em;\n  position: relative;\n  z-index: 10;\n}\n\n.villasDetails__imgContainer {\n  background-color: var(--clr-gray300);\n  width: 100%;\n  height: 15rem;\n  object-fit: cover;\n  cursor: zoom-in;\n  border-radius: 1em;\n}\n.villasDetails__imgContainer::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n}\n\n.villasDetails__img:hover {\n  opacity: 0.8;\n}\n\n.villasDetails__title {\n  font-weight: bolder;\n  font-size: 2rem;\n  margin-top: 1rem;\n}\n\n.villasDetails__moreDetails {\n  display: block;\n  margin: 0.75rem 0;\n}\n\n.villasDetails__description,\n.villasDetails__moreDetails {\n  line-height: 1.8;\n  white-space: pre-wrap;\n}\n\n.villasDetails__description {\n  color: var(--clr-gray800);\n  font-weight: 200;\n}\n\n.villasDetails__bottom {\n  display: flex;\n  align-items: center;\n  position: sticky;\n  justify-content: space-between;\n  width: calc(100% + 2rem);\n  padding: 1em;\n  bottom: -1rem;\n  margin: 1rem 0 -1rem -1rem;\n  background: var(--clr-secondary);\n}\n\n.villasDetails__price {\n  font-size: 1.5rem;\n  /* font-size: 3rem; */\n  font-weight: 500;\n  color: var(--clr-primary);\n}\n\n.villasDetails__price small {\n  font-weight: 700;\n  font-size: 1.5rem;\n}\n\n.villasDetails__bottom button {\n  border-radius: 1em;\n}\n.villasDetails__bottom button i {\n  margin-left: 1rem;\n}\n\n.villasDetails .btn.selected {\n  background: #fff;\n  border: 1px solid var(--clr-success-dark);\n  color: var(--clr-success-dark);\n}\n\n.villasDetails .btn.selected i::before,\n.villasDetails .btn.selected i::after {\n  background: var(--clr-success-dark);\n}\n\n.villaDetails__activityContainer h4 {\n  font-size: 1.15rem;\n  margin-top: 1.5rem;\n  font-weight: 500;\n}\n\n.villaDetails__activities {\n  margin-top: 0.5rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.villaDetails__activities li img {\n  width: 100%;\n  max-width: 2.5rem;\n  display: block;\n}\n.villaDetails__activities li {\n  display: flex;\n  padding: 0.75em 1em;\n  margin-right: 0.35rem;\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  background: var(--clr-secondary);\n  width: fit-content;\n  align-items: center;\n  border-radius: 0.5em;\n}\n\n/* @media (min-width: 425px) {\n  .villasDetails__price {\n    font-size: 3rem;\n  }\n} */\n\n@media (min-width: 768px) {\n  .villasDetails {\n    width: 60%;\n    border-radius: 1em 0 0 1em;\n  }\n}\n\n@media (min-width: 992px) {\n  .villasDetails {\n    width: 40%;\n  }\n\n  .villasDetails__imgContainer {\n    height: 22rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
